"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadsService = void 0;
var OpenAPI_1 = require("../core/OpenAPI");
var request_1 = require("../core/request");
var LeadsService = /** @class */ (function () {
    function LeadsService() {
    }
    /**
     * @param requestBody
     * @returns TableLeadsResponse Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsLeads = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/leads',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @returns LeadViewModel Success
     * @throws ApiError
     */
    LeadsService.getApiLeads = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Leads/{id}',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.putApiLeads = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/api/Leads/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.deleteApiLeads = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'DELETE',
            url: '/api/Leads/{id}',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param requestBody
     * @returns LeadViewModel Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsGetByIds = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/getByIds',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param requestBody
     * @returns number Success
     * @throws ApiError
     */
    LeadsService.postApiLeads = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsApprovalChange = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/approvalChange',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsUnassign = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/Unassign',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsAssign = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/Assign',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param request
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsMoveToReferInBulk = function (request) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/MoveToReferInBulk',
            body: request,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsLeaveComment = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/leaveComment',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsArchive = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/archive',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param requestBody
     * @returns ArchiveInBulkResponse Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsArchiveInBulk = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/ArchiveInBulk',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsSetAsNa = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/setAsNA',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsCsaAction = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/CSAAction',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsAssignStaffToSupplemental = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/AssignStaffToSupplemental',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @returns LeadViewModel Success
     * @throws ApiError
     */
    LeadsService.getApiLeadsSupplementalDetails = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Leads/{id}/supplementalDetails',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @returns LeadViewModel Success
     * @throws ApiError
     */
    LeadsService.getApiLeadsClassDetails = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Leads/{id}/classDetails',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.putApiLeadsUpdateSupplemental = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/api/Leads/{id}/updateSupplemental',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    LeadsService.getApiLeadsReferralCaseProgress = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Leads/{id}/referralCaseProgress',
            path: {
                'id': id,
            },
        });
    };
    LeadsService.putApiLeadsReferralCaseProgress = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/api/Leads/{id}/referralCaseProgress',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @returns string Success
     * @throws ApiError
     */
    LeadsService.putApiLeadsConvertToClass = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/api/Leads/{id}/convertToClass',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.putApiLeadsUpdateClass = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/api/Leads/{id}/updateClass',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.putApiLeadsConfirmCsaSigned = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/api/Leads/{id}/confirmCSASigned',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.putApiLeadsSendEmail = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/api/Leads/{id}/sendEmail',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.getApiLeadsPdfIntake = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Leads/{id}/pdfIntake',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.getApiLeadsPdfClass = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Leads/{id}/pdfClass',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.getApiLeadsPdfSupplemental = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Leads/{id}/pdfSupplemental',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsRestore = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/restore',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsShareLeads = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/shareLeads',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @returns LeadAttorneysResponse Success
     * @throws ApiError
     */
    LeadsService.getApiLeadsAttorneys = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Leads/{id}/attorneys',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsWinner = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/winner',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @returns UserShortResponse Success
     * @throws ApiError
     */
    LeadsService.getApiLeadsWinner = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/Leads/{id}/winner',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsConfirmIntake = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/confirmIntake',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsRejectIntake = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/rejectIntake',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsAgreementSend = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/agreement/send',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @returns string Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsAgreementSignurl = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/agreement/signurl',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsAgreementSign = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/agreement/sign',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsSetOpen = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/setOpen',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns boolean Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsAcceptLead = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/acceptLead',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsRejectLead = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/rejectLead',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsSavePayment = function (id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/savePayment',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsStartCase = function (id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/{id}/startCase',
            path: {
                'id': id,
            },
        });
    };
    /**
     * @param requestBody
     * @returns LeadsReport Success
     * @throws ApiError
     */
    LeadsService.postApiLeadsLeadsReport = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/Leads/leadsReport',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    };
    return LeadsService;
}());
exports.LeadsService = LeadsService;
//# sourceMappingURL=LeadsService.js.map